export const capital = 'Capital';
export const consumer = 'Consumable';
export const upgrade = 'Upgrade'